<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'WhoIsOnboard',
};
</script>

<style scoped>

</style>
